import { CONTRACT_URL, FINISHED_SETTLEMENTS_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { IApiResponse } from "../../models";

const defaultProvide = async () => await getToken();

interface SettlementProps {
  contractId?: string;
  referenceTransactionId?: string;
  createdAtTo?: Date | null | string;
  createdAtFrom?: Date | null | string;
  page: number;
  size: number;
  organizationCode?: string;
}

export const getActiveSettlements = ({
  contractId = "",
  createdAtTo = "",
  createdAtFrom = "",
  referenceTransactionId = "",
  page = 0,
  size = 10,
  organizationCode,
}: SettlementProps): Promise<IApiResponse> => {
  let searchKeyWord = "";
  if (contractId) searchKeyWord = contractId?.replace("+", "%2B");
  const url = `${CONTRACT_URL}calculate-ready-for-cashOut?page=${page}&size=${size}${
    contractId ? `&searchKeyWord=${searchKeyWord}` : ""
  }${createdAtTo ? `&createdAtTo=${createdAtTo}` : ""}${
    createdAtFrom ? `&createdAtFrom=${createdAtFrom}` : ""
  }${
    referenceTransactionId
      ? `&referenceTransactionId=${referenceTransactionId}`
      : ""
  }${organizationCode ? `&organizationCode=${organizationCode}` : ""}`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

export const getFinishedSettlements = ({
  contractId = "",
  createdAtTo = "",
  createdAtFrom = "",
  referenceTransactionId = "",
  page = 0,
  size = 10,
}: SettlementProps): Promise<IApiResponse> => {
  let searchKeyWord = "";
  if (contractId) searchKeyWord = contractId?.replace("+", "%2B");
  const url = `${FINISHED_SETTLEMENTS_URL}?status=CASH_OUT_APPROVED,COMPLETED,EXCEPTIONAL_COMPLETED&type=QUICK_TRANSACTION&page=${page}&size=${size}${
    contractId ? `&searchKeyWord=${searchKeyWord}` : ""
  }${createdAtTo ? `&createdAtTo=${createdAtTo}` : ""}${
    createdAtFrom ? `&createdAtFrom=${createdAtFrom}` : ""
  }${
    referenceTransactionId &&
    `&referenceTransactionId=${referenceTransactionId}`
  }`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};
